import { NgModule } from '@angular/core';

import { LayoutRoutingModule } from './layout-routing.module';
import { SharedModule } from '../shared/shared.module';
import { ToastModule } from 'ng2-toastr';
import { CountUpModule } from 'countup.js-angular2';
import {RestrictedAccessComponent} from '../layout/restrictedAccesss.component'
import {MatButtonModule}   from '@angular/material';

@NgModule({
  imports: [
    MatButtonModule,
    LayoutRoutingModule,
    SharedModule,
    ToastModule.forRoot(),
    
  ],
  declarations: [RestrictedAccessComponent],
  entryComponents: [RestrictedAccessComponent]
})

export class LayoutModule {}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/app/layout/layout.module.ts